import styled from 'styled-components';

export const HomeBaseWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 60px);
`;

export const SelectedResourceWrapper = styled.div<{ $theme?: string; $height?: number }>`
  width: 100%;
  height: ${props => props.$height + "px" || "100%"};
`;

export const ListAttendeeWrapper = styled.div<{ $theme?: string; $height?: number }>`
  width: 100%;
`;